<template>
<div>
    <!-- Loading Overlay -->
    <div v-if="submitted || productsLoading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <!-- Payment Error Display -->
    <div v-if="paymentError" class="error_popup popup-desktop" style="display:block;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101">Payment Error</div>
            <div class="text-block-1102">{{ errorMessage }}</div>
            <a href="#" @click.prevent="paymentError = false" class="close-error-link">Close</a>
        </div>
    </div>

    <!-- Learn More Dialog -->
    <up-sell-page-modal ref="learnMoreModal" :api-products="apiProducts || []" />
    <!-- Special template modal (e.g. NAD uses template_to_use === 2) — mirrors the store -->
    <store-learn-more-modal ref="storeLearnMoreModal" :products="storeLearnMoreProducts" />

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="236.8229217529297px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el > firstStep">
                    <a href="#" class="link-block-109 desktop-back w-inline-block" @click.prevent="goBack"><img src="@/assets/images/back_arrow.png" loading="lazy" alt="" class="image-692"></a>
                </div>
                <div class="mobile-nav-links">
                    <a href="#" class="link-block-109 w-inline-block" v-if="active_el > firstStep" @click.prevent="goBack"><img src="@/assets/images/back_arrow.png" loading="lazy" alt="" class="image-692"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress"></div>
            </div>
        </div>
    </section>
    <section class="section-fixed-controlnav hide-block">
        <div class="flow-ctrl-nav-wrap">
            <div class="ctrl-div">
                <div class="ctrl-div-flex">
                    <a href="#" class="back-button w-button">Back</a>
                    <a href="#" class="continue-button w-button">Continue</a>
                </div>
            </div>
        </div>
    </section>
    <section class="section_checkout-flow">
        <div class="flow_wrap">
            <div class="upsellflow_div-1" v-if="active_el==1 && showBundleStep">
                <div class="upsell-header-div">
                    <div class="upsell_header-2 flow">Build your personalized protocol for weight loss and beyond.</div>
                </div>
                <div class="upsell-bundle-div body_flow">
                    <div data-delay="4000" data-animation="slide" class="upsell-product-image-slider w-slider" data-slider-key="bundle" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
                        <div class="mask-14 w-slider-mask">
                            <div class="product-slide-upsell w-slide" v-for="(img, i) in productImages(bundleProduct)" :key="i">
                                <div class="upsell_bundleimgdiv-2"><img :src="img" :alt="bundleProduct.name" loading="lazy" class="upsell-bundle-img nopad"></div>
                            </div>
                        </div>
                        <div class="product-slider-left-arrow upsell side-arrow w-slider-arrow-left">
                            <div class="product-slider-arrow-icon-2 w-icon-slider-left"></div>
                        </div>
                        <div class="product-slider-right-arrow upsell side-arrows w-slider-arrow-right">
                            <div class="product-slider-arrow-icon-2 w-icon-slider-right"></div>
                        </div>
                        <div class="slide-nav-16 w-slider-nav w-round w-num"></div>
                    </div>
                    <div class="bundle_detailsdiv">
                        <div class="upsell_productname_pricediv">
                            <div class="prodname-div">
                                <div class="upsell-procuctname-copy-3 bundle-copy">{{ bundleProduct.name }}</div>
                                <div class="upsell_productsub_div">
                                    <div class="upsell-product-subtext-2"><strong>{{ (bundleProduct.marketing || {}).sub_header }}</strong></div>
                                </div>
                            </div>
                            <div class="upsell-price-main-div-copy">
                                <div class="upsell-prices-div flow">
                                    <div class="old-price">
                                        <div class="item-price-div">
                                            <div class="dollar-sign-2-copy">$</div>
                                            <div class="price-2-copy old upsell">{{ productOldPrice(bundleProduct, bundlePaymentTerms) }}</div><img width="69" loading="lazy" alt="" src="https://cdn.prod.website-files.com/67f763fb29be37044a363435/68010e3d8de415a9f84337e2_discount%20x-01.png" class="image-595-copy">
                                        </div>
                                    </div>
                                    <div class="program-amount-2">
                                        <div class="text-block-1730">$</div>
                                        <div class="program-price-2">{{ productPriceParts(bundleProduct, bundlePaymentTerms).dollars }}</div>
                                        <div>
                                            <div class="text-block-1729">.{{ productPriceParts(bundleProduct, bundlePaymentTerms).cents }}</div>
                                            <div class="text-block-1731">{{ bundlePaymentTerms === 3 ? '' : '/mo' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="upsell_paragraph-2 bundle">{{ (bundleProduct.marketing || {}).description }}</p>
                        <div class="w-form">
                            <form id="email-form-3" name="email-form-3" data-name="Email Form 3" method="get" class="form-25" data-wf-page-id="6967a7ef11f5549af313f96b" data-wf-element-id="dc173fc3-a2cd-ac54-9eff-1131719d0444">
                                <div class="pay-type-div">
                                <div class="div-block-2295">
                                    <div class="div-block-2293" v-if="productPlan(bundleProduct, 1)" :class="{ 'selected': bundlePaymentTerms === 1 }" @click="bundlePaymentTerms = 1"><label class="radio-button-field-5 w-radio"><input type="radio" name="radio-2" id="radio-2" data-name="Radio 2" class="w-form-formradioinput radio-button-5 w-radio-input" value="1" :checked="bundlePaymentTerms === 1" @change="bundlePaymentTerms = 1"><span class="radio-button-label-9 hide w-form-label" for="radio-2">Nasal</span>
                                        <div class="text-block-1789 hide">Easy Application</div>
                                        <div class="div-block-2294">
                                        <div class="text-block-1788">Monthly Supply</div>
                                        </div><img loading="lazy" src="images/icon_info_1.svg" alt="" class="info-2 hide">
                                    </label>
                                    <div class="popup-text-4">The easiest routine to stick with daily if you don&#x27;t like needles.</div>
                                    </div>
                                    <div class="div-block-2293" v-if="productPlan(bundleProduct, 3)" :class="{ 'selected': bundlePaymentTerms === 3 }" @click="bundlePaymentTerms = 3"><label class="radio-button-field-5 w-radio"><input type="radio" name="radio-2" id="radio-2" data-name="Radio 2" class="w-form-formradioinput radio-button-5 w-radio-input" value="3" :checked="bundlePaymentTerms === 3" @change="bundlePaymentTerms = 3"><span class="radio-button-label-9 hide w-form-label" for="radio-2">Nasal</span>
                                        <div class="text-block-1781-copy-2 hide">Highest Efficacy</div>
                                        <div class="div-block-2294">
                                        <div class="text-block-1788">3-Month Supply</div>
                                        </div><img loading="lazy" src="images/icon_info_1.svg" alt="" class="info-2 hide">
                                    </label>
                                    <div class="popup-text-3">Instant energy upgrade felt throughout the day without effecting sleep.</div>
                                    </div>
                                </div>
                                </div>
                            </form>
                            <div class="w-form-done">
                                <div>Thank you! Your submission has been received!</div>
                            </div>
                            <div class="w-form-fail">
                                <div>Oops! Something went wrong while submitting the form.</div>
                            </div>
                            </div>


                        <div class="bundle-items-div">
                            <div class="upsell-bundle-item-div" v-for="(component, idx) in bundleComponentProducts" :key="component.id">
                                <div class="bundle-item-div-2">
                                    <div class="item-number-div-2">
                                        <div class="text-block-1728">{{ idx + 1 }}</div>
                                    </div>
                                    <div class="upsell_productinfo_div-copy">
                                        <div class="choice-img-div-copy-2"><img :src="apiImage(component)" :alt="component.name" loading="lazy" class="newupsell_product_img rxpill"></div>
                                        <div class="upsell-text-side-div">
                                            <div class="upsell_productname_pricediv-copy">
                                                <div class="prodname-div">
                                                    <div class="upsell-procuctname-copy-2 flow">{{ component.name }}</div>
                                                    <div class="upsellflow_productsub_div">
                                                        <div class="upsell-product-subtext-2">{{ (component.marketing || {}).product_format || component.type }}</div>
                                                    </div>
                                                </div>
                                                <div class="flow-upsell-price-div">
                                                    <a href="#" class="button-176 w-button" @click.prevent="openLearnMore(component.id)"><span class="learn-more-text" style="transform: translateY(2px);">Learn More</span></a>
                                                </div>
                                            </div>
                                            <div class="product-description-div">
                                                <p class="paragraph-219 report upsell flow">{{ (component.marketing || {}).sub_header }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="upsell_buttons-stack-copy">
                            <div class="new-upsell-cart-button-2" :class="{ 'added': isInCart(bundleProduct.id) }" @click="addBundleAndSkip()">
                                <div class="cart-icon-div-2" v-if="!isInCart(bundleProduct.id)">
                                    <div class="code-embed-3-copy cart_btn  w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewbox="0 0 16 16">
                                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                        </svg></div>
                                </div>
                                <div>{{ isInCart(bundleProduct.id) ? '✓ ADDED' : 'ADD TO CART' }}</div>
                            </div>
                            <div class="upsell-buttons-flex hide-buttons">
                                <a href="#" class="upsell_learnbutton-2 w-button" @click.prevent="openLearnMore(bundleProduct.id)"><span class="learn-more-text">Learn More</span></a>
                                <a href="#" class="link-block-110 w-inline-block">
                                    <div class="div-block-2254"><img loading="lazy" src="@/assets/images/icon_faq.svg" alt="" class="image-693">
                                        <div>Ask a Question</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#" class="button-177 w-button" @click.prevent="goToNextStep"><strong>Skip</strong> <span class="text-span-424">-&gt;</span></a>
            </div>
            <div class="upsellflow_div2" v-if="active_el==2 && showIndividualStep">
                <div class="upsell-flow-header flow">Purchase Individually<br></div>
                <div class="upsellflow_subs">Get only the medication that you want</div>
                <div class="upsell-flow-formblock form-rep w-form">
                    <form id="email-form" name="email-form" data-name="Email Form" method="get" class="upsell-flow-form" data-wf-page-id="6967a7ef11f5549af313f96b" data-wf-element-id="cf47408b-72d4-ec89-54c0-343077ea67f3">
                        <div class="upsell-box-copy" v-for="product in individualStepProducts" :key="product.id">
                            <div class="solo-choice-main-div">
                                <div class="choice-box-flex">
                                    <div class="choice-box-div-1">
                                        <div class="choice-div-copy">
                                            <div class="choice-img-div"><img :src="apiImage(product)" :alt="product.name" loading="lazy" class="choice-img b12"></div>
                                            <div class="upsell-flow-text-side-div">
                                                <div class="nameprice-div-copy">
                                                    <div class="prodname-div">
                                                        <div class="choice-name flow">{{ product.name }}</div>
                                                        <div class="div-block-2105">
                                                            <div class="upsell-subtext">{{ (product.marketing || {}).product_format || product.type }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="upsell-price-main-div">
                                                        <div class="upsell-prices-div-copy">
                                                            <div class="old-price">
                                                                <div class="item-price-div">
                                                                    <div class="dollar-sign-2-copy">$</div>
                                                                    <div class="price-2-copy old upsell">{{ productOldPrice(product, productTermsFor(product)) }}</div><img width="69" loading="lazy" alt="" src="https://cdn.prod.website-files.com/67f763fb29be37044a363435/68010e3d8de415a9f84337e2_discount%20x-01.png" class="image-595-copy">
                                                                </div>
                                                            </div>
                                                            <div class="program-amount-copy">
                                                                <div class="text-block-728-copy">$</div>
                                                                <div class="program-price-copy flow">{{ productPriceParts(product, productTermsFor(product)).dollars }}</div>
                                                                <div>
                                                                    <div class="text-block-1451-copy">.{{ productPriceParts(product, productTermsFor(product)).cents }}</div>
                                                                    <div class="text-block-1452-copy">{{ productTermsFor(product) === 3 ? '' : '/mo' }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="product-description-div desk-only">
                                                    <p class="paragraph-126 report upsell flow">{{ (product.marketing || {}).sub_header }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="choice-info-mobile">
                                            <p class="solo-box-subs">{{ (product.marketing || {}).sub_header }}</p>
                                        </div>
                                        <div class="pay-type-div">
                                            <!-- Only the lengths this product has a price for, so no card shows $0. -->
                                            <div class="div-block-2295">
                                                <div class="div-block-2293" v-if="productPlan(product, 1)" :class="{ 'selected': productTermsFor(product) === 1 }" @click="setProductTerms(product, 1)">
                                                    <label class="radio-button-field-5 w-radio">
                                                        <input type="radio" :name="`terms-${product.id}`" class="w-form-formradioinput radio-button-5 w-radio-input" :checked="productTermsFor(product) === 1" @change="setProductTerms(product, 1)">
                                                        <div class="div-block-2294">
                                                            <div class="text-block-1788">Monthly Supply</div>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div class="div-block-2293" v-if="productPlan(product, 3)" :class="{ 'selected': productTermsFor(product) === 3 }" @click="setProductTerms(product, 3)">
                                                    <label class="radio-button-field-5 w-radio">
                                                        <input type="radio" :name="`terms-${product.id}`" class="w-form-formradioinput radio-button-5 w-radio-input" :checked="productTermsFor(product) === 3" @change="setProductTerms(product, 3)">
                                                        <div class="div-block-2294">
                                                            <div class="text-block-1788">3-Month Supply</div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-upsell-button-div">
                                            <div class="new-upsell-cart-button var1 flow" :class="{ 'added': isInCart(product.id) }" @click="addProductToCart(product, productTermsFor(product))">
                                                <div class="cart-icon-div" v-if="!isInCart(product.id)">
                                                    <div class="code-embed-3-copy cart_btn  w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewbox="0 0 16 16">
                                                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                                        </svg></div>
                                                </div>
                                                <div class="text-block-1714">{{ isInCart(product.id) ? '✓ ADDED' : 'ADD TO CART' }}</div>
                                            </div>
                                            <a href="#" class="button-153 w-button" @click.prevent="openLearnMore(product.id)"><span class="learn-more-text">Learn More</span></a>
                                            <div class="mobile-buttons-flex hide">
                                                <a href="#" class="button-153-copy w-button" @click.prevent="openLearnMore(product.id)"><span class="learn-more-text">Learn More</span></a>
                                                <a href="#" class="link-block-95 w-inline-block">
                                                    <div class="div-block-2134"><img src="@/assets/images/icon_faq.svg" loading="lazy" alt="" class="image-620">
                                                        <div>Ask a Question</div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-block-1449 tirz b12 hide-in-blk">Weight Loss</div>
                        </div>
                        <a href="#" class="button-149 w-button" @click.prevent="goToNextStep"><strong class="bold-text-43">Continue</strong> <span class="text-span-340">-&gt;</span></a>
                    </form>
                    <div class="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div class="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>
            </div>
            <div class="upsellflow_div3" v-if="(active_el==3 && showNadStep) || (active_el==4 && showSermorelinStep)">
                <div class="upsell-flow-header flow" v-if="active_el==3">The Mitochondrial Superfuel<br></div>
                <div class="upsellflow_subs" v-if="active_el==3">Feel like you did in your 20s for the Next 20 Years.</div>
                <div class="upsell-flow-header flow" v-if="active_el==4">Protect Lean Muscle While You Lose Weight<br></div>
                <div class="upsellflow_subs" v-if="active_el==4">Don't be skinny fat—Sermorelin helps preserve muscle, support recovery, maintain a strong metabolism, and promote tighter, healthier-looking skin as you slim down.</div>
                <div class="upsell-flow-formblock form-rep w-form">
                    <form id="email-form" name="email-form" data-name="Email Form" method="get" class="upsell-flow-form" data-wf-page-id="6967a7ef11f5549af313f96b" data-wf-element-id="5ef13e13-071d-e3bd-7b38-c4bdd7221569">
                        <div class="upsell-bundle-div flow" v-if="active_el==3">
                            <div data-delay="4000" data-animation="slide" class="upsell-product-image-slider w-slider" data-slider-key="nad" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
                                <div class="mask-10 w-slider-mask">
                                    <div class="product-slide-upsell w-slide" v-for="(img, i) in productImages(selectedNadProduct)" :key="i">
                                        <div class="upsell_bundleimgdiv"><img :src="img" :alt="selectedNadProduct.name" loading="lazy" class="upsell-bundle-img nopad"></div>
                                    </div>
                                </div>
                                <div class="product-slider-left-arrow upsell w-slider-arrow-left">
                                    <div class="product-slider-arrow-icon w-icon-slider-left"></div>
                                </div>
                                <div class="product-slider-right-arrow upsell w-slider-arrow-right">
                                    <div class="product-slider-arrow-icon w-icon-slider-right"></div>
                                </div>
                                <div class="slide-nav-4 w-slider-nav w-round w-num"></div>
                            </div>
                            <div class="bundle_detailsdiv">
                                <div class="upsell_productname_pricediv">
                                    <div class="prodname-div">
                                        <div class="upsell-procuctname bundle">{{ selectedNadProduct.name }}</div>
                                        <div class="upsell_productsub_div">
                                            <div class="upsell-product-subtext">{{ (selectedNadProduct.marketing || {}).sub_header }}</div>
                                        </div>
                                    </div>
                                    <div class="upsell-price-main-div"></div>
                                </div>
                                <p class="upsell_paragraph bundle">{{ (selectedNadProduct.marketing || {}).description }}</p>
                                <div class="benefits_div bundle" v-if="splitBenefits(selectedNadProduct).left.length || splitBenefits(selectedNadProduct).right.length">
                                    <div class="upsell_bullets_div">
                                        <div class="div-block-1948" v-for="(b, i) in splitBenefits(selectedNadProduct).left" :key="'nl' + i"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="upsell_bullet_img">
                                            <div class="upsell-bullet-text no-highlight">{{ b }}</div>
                                        </div>
                                    </div>
                                    <div class="upsell_bullets_div">
                                        <div class="div-block-1948" v-for="(b, i) in splitBenefits(selectedNadProduct).right" :key="'nr' + i"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="upsell_bullet_img">
                                            <div class="upsell-bullet-text no-highlight">{{ b }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="med-type-div">
                                    <div class="text-block-1776" v-if="nadNasalProduct && nadInjectableProduct">Choose Medication</div>
                                    <div class="div-block-2295" v-if="nadNasalProduct && nadInjectableProduct">
                                        <div class="div-block-2293" :class="{ 'selected': nadMedType === 'nasal' }" @click="nadMedType = 'nasal'"><label class="radio-button-field-5 w-radio"><input type="radio" name="nad-med-type" id="nad-nasal" class="w-form-formradioinput radio-button-5 w-radio-input" value="nasal" v-model="nadMedType"><span class="radio-button-label-9 hide w-form-label" for="nad-nasal">Nasal</span>
                                                <div class="text-block-1789">Easy Application</div>
                                                <div class="div-block-2294"><img :src="apiImage(nadNasalProduct)" :alt="nadNasalProduct.name" loading="lazy" class="medtype-img-2">
                                                    <div class="text-block-1788">Nasal</div>
                                                </div><img data-w-id="6dbb6508-a103-cf31-44e8-5a58eb30e445" loading="lazy" alt="" src="@/assets/images/icon_info_1.svg" class="info-2">
                                            </label>
                                            <div class="popup-text-4">The easiest routine to stick with daily if you don&#x27;t like needles.</div>
                                        </div>
                                        <div class="div-block-2293" :class="{ 'selected': nadMedType === 'injectable' }" @click="nadMedType = 'injectable'"><label class="radio-button-field-5 w-radio"><input type="radio" name="nad-med-type" id="nad-injectable" class="w-form-formradioinput radio-button-5 w-radio-input" value="injectable" v-model="nadMedType"><span class="radio-button-label-9 hide w-form-label" for="nad-injectable">Injectable</span>
                                                <div class="text-block-1781-copy-2">Highest Efficacy</div>
                                                <div class="div-block-2294"><img :src="apiImage(nadInjectableProduct)" :alt="nadInjectableProduct.name" loading="lazy" class="medtype-img-2">
                                                    <div class="text-block-1788">Injectable</div>
                                                </div><img data-w-id="6dbb6508-a103-cf31-44e8-5a58eb30e453" loading="lazy" alt="" src="@/assets/images/icon_info_1.svg" class="info-2">
                                            </label>
                                            <div class="popup-text-3">Instant energy upgrade felt throughout the day without effecting sleep.</div>
                                        </div>
                                    </div>
                                    <div class="text-block-1776 plan">Choose Payment Plan</div>
                                </div>
                                <div class="_3-button-div">
                                    <div class="upsell_option" v-if="nadPlanData.oneTime" :class="{ 'selected': nadPaymentPlan === 0 }" @click="nadPaymentPlan = 0"><label class="radio-button-field-3 w-radio"><input type="radio" name="nad-payment-plan" id="nad-onetime" class="w-form-formradioinput w-radio-input" value="0" v-model.number="nadPaymentPlan"><span class="radio-button-label-7 w-form-label" for="nad-onetime">One Time</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="text-block-1773 flow">1 Month Supply</div>
                                                    <p class="paragraph-230">One Time Purchase</p>
                                                </div>
                                                <div class="div-block-2281">
                                                    <div class="option-price flow"><span class="text-span-442"><sup class="price-cents">$</sup></span>{{ nadPlanData.oneTime.dollars }}<sup class="price-cents">{{ nadPlanData.oneTime.cents }}</sup><span class="text-span-440">/mo</span></div>
                                                    <div class="text-block-1774"><strong>1 Month Supply</strong></div>
                                                    <div class="text-block-1775">Monthly Doctor Review</div>
                                                </div>
                                            </div>
                                        </label></div>
                                    <div class="upsell_option" v-if="nadPlanData.monthly" :class="{ 'selected': nadPaymentPlan === 1 }" @click="nadPaymentPlan = 1"><label class="radio-button-field-3 w-radio"><input type="radio" name="nad-payment-plan" id="nad-monthly" class="w-form-formradioinput w-radio-input" value="1" v-model.number="nadPaymentPlan"><span class="radio-button-label-7 w-form-label" for="nad-monthly">Monthly</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="text-block-1773 flow">Subscribe &amp; Save</div>
                                                    <p class="paragraph-230">Never miss a refill &amp; Save</p>
                                                </div>
                                                <div class="div-block-2281">
                                                    <div class="option-price flow"><sup class="price-cents">$</sup>{{ nadPlanData.monthly.dollars }}<sup class="price-cents">{{ nadPlanData.monthly.cents }}</sup><span class="text-span-440">/mo</span></div>
                                                    <div class="text-block-1775">1 Month Supply<br>‍<span class="text-span-441">Save with subscription!</span></div>
                                                </div>
                                            </div>
                                        </label></div>
                                    <div class="upsell_option" v-if="nadPlanData.threeMonthAvg" :class="{ 'selected': nadPaymentPlan === 3 }" @click="nadPaymentPlan = 3"><label class="radio-button-field-3 w-radio"><input type="radio" name="nad-payment-plan" id="nad-3month" class="w-form-formradioinput w-radio-input" value="3" v-model.number="nadPaymentPlan"><span class="radio-button-label-7 w-form-label" for="nad-3month">3 Months</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="text-block-1773 flow">3 Month Supply</div>
                                                    <p class="paragraph-230">Commit Longer, Save More.</p>
                                                </div>
                                                <div class="div-block-2281">
                                                    <div class="option-price flow"><sup class="price-cents">$</sup>{{ nadPlanData.threeMonthAvg.dollars }}<sup class="price-cents">{{ nadPlanData.threeMonthAvg.cents }}</sup><span class="text-span-440">/mo Avg.</span></div>
                                                    <div class="text-block-1775">Pay <strong>${{ nadPlanData.threeMonthTotal }}</strong> Today<br><strong>Best Value!</strong></div>
                                                </div>
                                            </div>
                                        </label></div>
                                </div>
                                <div class="form-upsell-button-div">
                                    <div class="new-upsell-cart-button var1 flow" :class="{ 'added': isNadInCart() }" @click="addNadAndNext()">
                                        <div class="cart-icon-div" v-if="!isNadInCart()">
                                            <div class="code-embed-3-copy cart_btn  w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewbox="0 0 16 16">
                                                    <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                                </svg></div>
                                        </div>
                                        <div class="text-block-1714">{{ isNadInCart() ? '✓ ADDED' : 'ADD TO CART' }}</div>
                                    </div>
                                    <a href="#" class="button-153 w-button" @click.prevent="openLearnMore(selectedNadProduct.id)"><span class="learn-more-text">Learn More</span></a>
                                    <div class="mobile-buttons-flex hide">
                                        <a href="#" class="button-153-copy w-button" @click.prevent="openLearnMore(selectedNadProduct.id)"><span class="learn-more-text">Learn More</span></a>
                                        <a href="#" class="link-block-95 w-inline-block">
                                            <div class="div-block-2134"><img src="@/assets/images/icon_faq.svg" loading="lazy" alt="" class="image-620">
                                                <div>Ask a Question</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <a href="#" class="button-149-copy w-button" @click.prevent="goToNextStep"><strong class="bold-text-43">&quot;I am not interested in Energy Support&quot; </strong> <span class="text-span-340">-&gt;</span></a>
                            </div>
                        </div>
                        <div class="upsell-bundle-div flow" v-if="active_el==4">
                            <div data-delay="4000" data-animation="slide" class="upsell-product-image-slider w-slider" data-slider-key="sermorelin" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
                                <div class="mask-10 w-slider-mask">
                                    <div class="product-slide-upsell w-slide" v-for="(img, i) in productImages(sermorelinProductRef)" :key="i">
                                        <div class="upsell_bundleimgdiv"><img :src="img" :alt="sermorelinProductRef.name" loading="lazy" class="upsell-bundle-img nopad"></div>
                                    </div>
                                </div>
                                <div class="product-slider-left-arrow upsell w-slider-arrow-left">
                                    <div class="product-slider-arrow-icon w-icon-slider-left"></div>
                                </div>
                                <div class="product-slider-right-arrow upsell w-slider-arrow-right">
                                    <div class="product-slider-arrow-icon w-icon-slider-right"></div>
                                </div>
                                <div class="slide-nav-4 w-slider-nav w-round w-num"></div>
                            </div>
                            <div class="bundle_detailsdiv">
                                <div class="upsell_productname_pricediv">
                                    <div class="prodname-div">
                                        <div class="upsell-procuctname bundle">{{ sermorelinProductRef.name }}</div>
                                        <div class="upsell_productsub_div">
                                            <div class="upsell-product-subtext">{{ (sermorelinProductRef.marketing || {}).sub_header }}</div>
                                        </div>
                                    </div>
                                    <div class="upsell-price-main-div"></div>
                                </div>
                                <p class="upsell_paragraph bundle">{{ (sermorelinProductRef.marketing || {}).description }}</p>
                                <div class="benefits_div bundle" v-if="splitBenefits(sermorelinProductRef).left.length || splitBenefits(sermorelinProductRef).right.length">
                                    <div class="upsell_bullets_div">
                                        <div class="div-block-1948" v-for="(b, i) in splitBenefits(sermorelinProductRef).left" :key="'sl' + i"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="upsell_bullet_img">
                                            <div class="upsell-bullet-text no-highlight">{{ b }}</div>
                                        </div>
                                    </div>
                                    <div class="upsell_bullets_div">
                                        <div class="div-block-1948" v-for="(b, i) in splitBenefits(sermorelinProductRef).right" :key="'sr' + i"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="upsell_bullet_img">
                                            <div class="upsell-bullet-text no-highlight">{{ b }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="_3-button-div">
                                    <div class="upsell_option" v-if="sermorelinPlanData.oneTime" :class="{ 'selected': sermorelinPaymentPlan === 0 }" @click="sermorelinPaymentPlan = 0"><label class="radio-button-field-3 w-radio"><input type="radio" name="sermorelin-payment-plan" id="sermorelin-onetime" class="w-form-formradioinput w-radio-input" value="0" v-model.number="sermorelinPaymentPlan"><span class="radio-button-label-7 w-form-label" for="sermorelin-onetime">One Time</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="text-block-1773 flow">1 Month Supply</div>
                                                    <p class="paragraph-230">One Time Purchase</p>
                                                </div>
                                                <div class="div-block-2281">
                                                    <div class="option-price flow"><span class="text-span-442"><sup class="price-cents">$</sup></span>{{ sermorelinPlanData.oneTime.dollars }}<sup class="price-cents">{{ sermorelinPlanData.oneTime.cents }}</sup><span class="text-span-440">/mo</span></div>
                                                    <div class="text-block-1774"><strong>1 Month Supply</strong></div>
                                                    <div class="text-block-1775">Monthly Doctor Review</div>
                                                </div>
                                            </div>
                                        </label></div>
                                    <div class="upsell_option" v-if="sermorelinPlanData.monthly" :class="{ 'selected': sermorelinPaymentPlan === 1 }" @click="sermorelinPaymentPlan = 1"><label class="radio-button-field-3 w-radio"><input type="radio" name="sermorelin-payment-plan" id="sermorelin-monthly" class="w-form-formradioinput w-radio-input" value="1" v-model.number="sermorelinPaymentPlan"><span class="radio-button-label-7 w-form-label" for="sermorelin-monthly">Monthly</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="text-block-1773 flow">Subscribe &amp; Save</div>
                                                    <p class="paragraph-230">Never miss a refill &amp; Save</p>
                                                </div>
                                                <div class="div-block-2281">
                                                    <div class="option-price flow"><sup class="price-cents">$</sup>{{ sermorelinPlanData.monthly.dollars }}<sup class="price-cents">{{ sermorelinPlanData.monthly.cents }}</sup><span class="text-span-440">/mo</span></div>
                                                    <div class="text-block-1775">1 Month Supply<br>‍<span class="text-span-441">Save with subscription!</span></div>
                                                </div>
                                            </div>
                                        </label></div>
                                    <div class="upsell_option" v-if="sermorelinPlanData.threeMonthAvg" :class="{ 'selected': sermorelinPaymentPlan === 3 }" @click="sermorelinPaymentPlan = 3"><label class="radio-button-field-3 w-radio"><input type="radio" name="sermorelin-payment-plan" id="sermorelin-3month" class="w-form-formradioinput w-radio-input" value="3" v-model.number="sermorelinPaymentPlan"><span class="radio-button-label-7 w-form-label" for="sermorelin-3month">3 Months</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="text-block-1773 flow">3 Month Supply</div>
                                                    <p class="paragraph-230">Commit Longer, Save More.</p>
                                                </div>
                                                <div class="div-block-2281">
                                                    <div class="option-price flow"><sup class="price-cents">$</sup>{{ sermorelinPlanData.threeMonthAvg.dollars }}<sup class="price-cents">{{ sermorelinPlanData.threeMonthAvg.cents }}</sup><span class="text-span-440">/mo Avg.</span></div>
                                                    <div class="text-block-1775">Pay <strong>${{ sermorelinPlanData.threeMonthTotal }}</strong> Today<br><strong>Best Value!</strong></div>
                                                </div>
                                            </div>
                                        </label></div>
                                </div>
                                <div class="form-upsell-button-div">
                                    <div class="new-upsell-cart-button var1 flow" :class="{ 'added': isInCart(sermorelinProductRef.id) }" @click.prevent="addSermorelinAndNext()">
                                        <div class="cart-icon-div" v-if="!isInCart(sermorelinProductRef.id)">
                                            <div class="code-embed-3-copy cart_btn  w-embed"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewbox="0 0 16 16">
                                                    <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                                </svg></div>
                                        </div>
                                        <div class="text-block-1714">{{ isInCart(sermorelinProductRef.id) ? '✓ ADDED' : 'ADD TO CART' }}</div>
                                    </div>
                                    <a href="#" class="button-153 w-button" @click.prevent="openLearnMore(sermorelinProductRef.id)"><span class="learn-more-text">Learn More</span></a>
                                    <div class="mobile-buttons-flex hide">
                                        <a href="#" class="button-153-copy w-button" @click.prevent="openLearnMore(sermorelinProductRef.id)"><span class="learn-more-text">Learn More</span></a>
                                        <a href="#" class="link-block-95 w-inline-block">
                                            <div class="div-block-2134"><img src="@/assets/images/icon_faq.svg" loading="lazy" alt="" class="image-620">
                                                <div>Ask a Question</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <a href="#" class="button-149-copy w-button" @click.prevent="goToNextStep"><strong class="bold-text-43">I do not have to worry about muscle loss</strong> <span class="text-span-340">-&gt;</span></a>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
            <div class="step4_div" v-if="active_el==5">
                <div class="inclusions-new">
                    <div class="flow-inclusions-header">Order Confirmation</div>
                    <div class="flow_inclusions-div">
                        <!-- Empty cart message -->
                        <div v-if="localCartItems.length === 0" class="empty-cart-message">
                            <p class="inclusions-subs" style="text-align: center; padding: 20px;">Your cart is empty. Go back to add items.</p>
                        </div>
                        <!-- Dynamic cart items -->
                        <div class="flow-inclusion-entry-div" v-for="item in localCartItems" :key="item.plan_id">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img :src="apiImageById(item.product_id)" loading="lazy" alt=""></div>
                                <div class="inclusions-text-div product">
                                    <div class="text-block-1706">{{ item.name }}</div>
                                    <p class="inclusions-subs">{{ item.terms === 3 ? '3 Month Supply' : item.terms === 1 ? 'Monthly Subscription' : 'One Time Purchase' }}</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="div-block-2249 top-float">
                                    <div class="order-item-price">${{ formatCartItemPrice(item.price).dollars }}<span><sup class="superscript-11">{{ formatCartItemPrice(item.price).cents }}</sup></span></div>
                                </div>
                                <a href="#" class="trash-link w-inline-block" @click.prevent="removeFromCart(item.plan_id)"><img src="@/assets/images/icon_trash.svg" loading="lazy" alt="" class="image-713"></a>
                            </div>
                        </div>
                        <!-- Static inclusions (always shown) -->
                        
                    </div>
                    <div class="row-divider"></div>
                    <div class="div-block-2248 total">
                        <div class="text-block-1712">Total</div>
                        <div class="div-block-2249">
                            <div class="text-block-1711-copy total">${{ formatCartTotal().dollars }}<span><sup class="superscript-11 total">{{ formatCartTotal().cents }}</sup></span></div>
                        </div>
                    </div>

                    <!-- Payment Method Section -->
                    <div class="payment-method-section">
                        <div class="row-divider"></div>
                        <div class="payment-method-header">
                            <div class="text-block-1712">Payment Method</div>
                        </div>

                        <!-- Existing Card on File -->
                        <div v-if="!showCardUpdate && hasCardOnFile" class="existing-card-display">
                            <div class="card-info-row">
                                <div class="card-icons">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/visa.webp" class="card-icon">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/mastercard.webp" class="card-icon">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/AmEx.webp" class="card-icon">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/discover.webp" class="card-icon">
                                </div>
                                <div class="card-number">Card ending in {{ cardLastFour }}</div>
                            </div>
                            <a href="#" class="update-card-link" @click.prevent="showCardUpdate = true">Update Card</a>
                        </div>

                        <!-- Update Card Form (Payment Element) -->
                        <div v-if="showCardUpdate">
                            <stripe-payment-element
                                ref="stripePayment"
                                :base-url="baseUrl"
                                :user-id="user?.id"
                                :user-name="`${user?.first_name || ''} ${user?.last_name || ''}`.trim()"
                                :user-email="user?.email"
                                :hide-address-fields="true"
                                :billing-address="stripeBillingAddress"
                                @ready="hasCardInput = $event"
                                @error="handlePaymentError"
                                @token="handlePaymentToken"
                            />
                            <a v-if="hasCardOnFile" href="#" class="cancel-update-link" @click.prevent="cancelCardUpdate">Cancel</a>
                        </div>
                    </div>

                    <div class="flow-ctrls-div">
                        
                        <a href="#" class="continue-button step w-button" style="width: 100%;" :class="{ 'disabled': submitted || !canCompleteOrder }" @click.prevent="confirmOrder">
                            {{ submitted ? 'Processing...' : 'Complete Order' }} <span class="text-span-423">&gt;</span>
                        </a>
                    </div>
                    <div class="flow-ctrls-div">
                        <p class="paragraph-185">
                                By clicking “Complete Order”, you agree to enroll in a 3-month program, with automatic renewal and charges until canceled. You authorize NewSelf to charge the payment method currently on file for all applicable program fees and renewals. You also confirm that you have read and agree to the
                                <a href="https://newself.com/returns-and-refund" target="_blank">Refund Policy</a>,
                                <a href="https://newself.com/terms-of-use" target="_blank">Terms and Conditions</a>,
                                <a href="https://newself.com/terms-of-use" target="_blank">Terms of Use</a>,
                                <a href="https://newself.com/privacy-policy" target="_blank">Privacy Policy</a>, and
                                <a href="/documents/Telehealth_Consent_Form.pdf" target="_blank">Telehealth Consent</a>, and that you are at least 18 years of age.
                            </p>
                        
                    </div>
                </div>
            </div>
            <div class="trust-pilot-div"><img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
                <div class="flow-rating-div">
                    <div class="text-block-1723">Excellent</div>
                    <div class="text-block-1724">4.6 out of 5</div><img src="@/assets/images/Trustpilot_Logo_2022.svg.webp" loading="lazy" sizes="237.69097900390625px" srcset="@/assets/images/Trustpilot_Logo_2022.svg-p-500.png 500w, @/assets/images/Trustpilot_Logo_2022.svg-p-800.png 800w, @/assets/images/Trustpilot_Logo_2022.svg-p-1080.png 1080w, @/assets/images/Trustpilot_Logo_2022.svg.webp 2560w" alt="" class="image-690">
                </div>
                <div>Trusted by thousands of members</div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import UpSellPageModal from './upSellPageModal.vue';
import StoreLearnMoreModal from '@/components/dashboard/store/StoreLearnMoreModal.vue';
import StripePaymentElement from '../common/StripePaymentElement.vue';
import { fetchProductsFromServer } from '@/utils/productData';
import {
    INTERNAL_IDS,
    getActiveAddons,
    getProductByInternalId,
    getProductById,
    getBundleProduct,
    getBundleComponents,
    getIndividualStepProducts,
    passesGenderRestriction,
    filterByGender,
    getPlan,
    getPlansForProduct,
    formatPrice,
    inflatedPrice,
    getProductImage,
    normalizeImageUrl,
    holdsNad,
    pricedTerms,
    pickTerms,
    UPSELL_TERMS,
    CARD_TERMS
} from './upsellAdapter';

export default {
    name: 'UpSellPage',
    components: {
        UpSellPageModal,
        StoreLearnMoreModal,
        StripePaymentElement
    },
    props: ['baseUrl', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 0, // Set to first enabled step in mounted
            localCartItems: [],
            // NAD selection state
            nadMedType: 'injectable', // 'nasal' or 'injectable'
            nadPaymentPlan: null, // 0 = one-time, 1 = monthly, 3 = 3-months (initialized in mounted)
            // Sermorelin selection state
            sermorelinPaymentPlan: null, // 0 = one-time, 1 = monthly, 3 = 3-months (initialized in mounted)
            bundlePaymentTerms: null, // 1 = monthly, 3 = 3-months (initialized in mounted)
            // Per-product payment terms for the individual step, keyed by product.id.
            productTerms: {},
            // Payment state
            submitted: false,
            correlationId: null,
            paymentError: false,
            errorMessage: '',
            hasCardInput: false,
            paymentToken: null,
            showCardUpdate: false,
            paymentData: null, // Saved card-on-file from /api/subscription-items (same source as the billing page)
            // Raw products from /api/get-all-products — the single source of truth for
            // visibility, copy, images and pricing (via each product's pricing_plans).
            apiProducts: null,
            // True until products have loaded; gates the funnel and shows a spinner.
            productsLoading: true,
            // One NAD+ per order: true while the shopper's subscriptions hold a NAD+, or
            // until they load. Hides the NAD step.
            holdsNadPlus: true,
            // Slider states for each product section
            sliders: {
                bundle: {
                    currentSlide: 0,
                    totalSlides: 3,
                    isAnimating: false
                },
                nad: {
                    currentSlide: 0,
                    totalSlides: 3,
                    isAnimating: false
                },
                sermorelin: {
                    currentSlide: 0,
                    totalSlides: 3,
                    isAnimating: false
                }
            },
            startX: 0,
            endX: 0
        }
    },
    async mounted() {
        window.addEventListener('pageshow', this.handlePageShow);
        // Initialize payment plan selections based on payment_terms query parameter
        const terms = this.$route?.query?.payment_terms;
        let paymentTerms = terms ? parseInt(terms) : 1; // Default to monthly (1)
        if(paymentTerms>=3){
            paymentTerms=3;
        }
        this.nadPaymentPlan = paymentTerms;
        this.sermorelinPaymentPlan = paymentTerms;
        this.bundlePaymentTerms = paymentTerms;

        this.fireGTM();

        // Load products (visibility) + plans (pricing) from the DB, then start the
        // funnel on the first active step. If every upsell is inactive, loadUpsellData
        // redirects to the thank-you page instead. The card is fetched later by the
        // active_el watcher when the user reaches step 5 with items — by then the
        // backend has attached the card from the prior checkout.
        await this.loadUpsellData();
        this.initSliders();
    },
    watch: {
        // Scroll to top and reinitialize sliders whenever step changes
        active_el(newStep) {
            // If cart is empty and reaching step 5, skip to thanks page
            if (newStep === 5 && this.localCartItems.length === 0) {
                this.$router.push('/payment/thanks');
                return;
            }
            // Check the card on file only when the user reaches the order-confirmation
            // step — by now the backend has attached the card from the prior checkout.
            if (newStep === 5) {
                this.fetchCardOnFile();
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // Reinitialize sliders after DOM updates (for newly rendered sliders)
            this.$nextTick(() => {
                this.initSliders();
            });
        },
        // Re-sync the NAD cart line when the plan or medication type changes.
        nadPaymentPlan() {
            if (this.isNadInCart()) {
                this.updateNadInCart();
            }
        },
        nadMedType() {
            if (this.isNadInCart()) {
                this.updateNadInCart();
            }
        },
        // Re-sync the Sermorelin cart line when its plan changes.
        sermorelinPaymentPlan() {
            if (this.sermorelinProductRef && this.isInCart(this.sermorelinProductRef.id)) {
                this.updateSermorelinInCart();
            }
        },
    },
    computed: {
        ...mapGetters(['user']),
        // Last 4 of the card on file — read from the exact same source/shape the billing page uses.
        cardLastFour() {
            if (this.paymentData?.payment_data?.cardDetails?.number) {
                return this.paymentData.payment_data.cardDetails.number.slice(-4);
            }
            return null;
        },
        // True only when the backend confirms a reusable card is attached to the customer.
        hasCardOnFile() {
            return !!this.cardLastFour;
        },
        // The order can be completed only with a card on file OR a fully-entered new card.
        canCompleteOrder() {
            return this.hasCardOnFile || this.hasCardInput;
        },
        // Address fed to Stripe (incl. ZIP/country) so we can hide its Country/ZIP UI.
        // Pulled from the same subscription-items payload — shape already matches what
        // StripePaymentElement expects: { addressLine1, addressLine2, city, state, zip }.
        stripeBillingAddress() {
            return this.paymentData?.payment_data?.billingAddress || null;
        },
        // Bundle step shows only when the bundle product is an active addon.
        showBundleStep() {
            return !!this.bundleProduct;
        },
        // Step 2 shows when at least one individual addon is active (gender-filtered).
        showIndividualStep() {
            return this.individualStepProducts.length > 0;
        },
        // NAD step shows when either NAD product (injectable/nasal) is an active addon.
        showNadStep() {
            return !!this.nadInjectableProduct || !!this.nadNasalProduct;
        },
        // Sermorelin step shows when the Sermorelin product is an active addon.
        showSermorelinStep() {
            return !!this.sermorelinProductRef;
        },
        // Ordered list of enabled steps (5 = checkout, always present)
        activeSteps() {
            const steps = [];
            if (this.showBundleStep) steps.push(1);
            if (this.showIndividualStep) steps.push(2);
            if (this.showNadStep) steps.push(3);
            if (this.showSermorelinStep) steps.push(4);
            steps.push(5);
            return steps;
        },
        firstStep() {
            return this.activeSteps[0];
        },
        // Get payment_terms from query parameter (1 = monthly, 3 = 3 months)
        // Cap at 3 for add-ons (even if main product was 6 or 12 months)
        paymentTerms() {
            const terms = this.$route?.query?.payment_terms;
            if (!terms) return null;
            const parsedTerms = parseInt(terms);
            return parsedTerms >= 3 ? 3 : parsedTerms;
        },
        // Cart items
        cartItems() {
            return this.localCartItems;
        },
        // Cart total
        cartTotal() {
            return this.localCartItems.reduce((total, item) => {
                const price = parseFloat(item.price.toString());
                return total + (price * item.quantity);
            }, 0);
        },
        // Cart total without discount (for showing savings)
        cartTotalNoDiscount() {
            return this.localCartItems.reduce((total, item) => {
                const price = parseFloat(item.retail_price?.toString() || item.price.toString());
                return total + (price * item.quantity);
            }, 0);
        },
        // The NAD product matching the medication-type toggle (falls back to whichever exists).
        selectedNadProduct() {
            const wanted = this.nadMedType === 'nasal' ? this.nadNasalProduct : this.nadInjectableProduct;
            return wanted || this.nadInjectableProduct || this.nadNasalProduct || null;
        },
        // Ids of the active NAD products (used to find any NAD line in the cart).
        nadProductIds() {
            return [this.nadInjectableProduct, this.nadNasalProduct].filter(Boolean).map(p => p.id);
        },
        // NAD payment-plan prices, from the selected product's pricing_plans.
        nadPlanData() {
            return this.planData(this.selectedNadProduct);
        },
        // Sermorelin payment-plan prices, from its pricing_plans.
        sermorelinPlanData() {
            return this.planData(this.sermorelinProductRef);
        },

        /* ===== NEW DB-DRIVEN DATA LAYER (adapter-backed, internal_id contract) ===== */
        /* Mirrors forms-newself products.ts. Drives the converted template steps.     */
        // Active addon products (is_active && is_addon), gender-filtered.
        activeAddonProducts() {
            return filterByGender(getActiveAddons(this.apiProducts), this.user);
        },
        // Products shaped for StoreLearnMoreModal (id/slug/templateToUse) — drives the
        // special template modal (e.g. NAD = template_to_use 2). Mirrors StorePage normalization.
        storeLearnMoreProducts() {
            if (!Array.isArray(this.apiProducts)) return [];
            return this.apiProducts.map(p => ({
                id: p.id,
                slug: p.url || null,
                templateToUse: p.template_to_use || null
            }));
        },
        // The GLP bundle product (only when an active addon with a Monthly or 3-Month price).
        bundleProduct() {
            const p = getBundleProduct(this.apiProducts);
            return (p && p.is_active === true && p.is_addon === true && pricedTerms(p, CARD_TERMS).length) ? p : null;
        },
        // Bundle breakdown rows — component products from bundle_components, gender-filtered.
        bundleComponentProducts() {
            return filterByGender(getBundleComponents(this.apiProducts, this.bundleProduct), this.user);
        },
        // Step-2 products: active addons not routed to a dedicated step, gender-filtered.
        individualStepProducts() {
            return filterByGender(getIndividualStepProducts(this.apiProducts), this.user);
        },
        // Looked up among the active add-ons (priced, not blocked). None while the shopper
        // already holds a NAD+: one NAD+ per order.
        nadInjectableProduct() {
            if (this.holdsNadPlus) return null;
            return getProductByInternalId(this.activeAddonProducts, INTERNAL_IDS.NAD) || null;
        },
        nadNasalProduct() {
            if (this.holdsNadPlus) return null;
            return getProductByInternalId(this.activeAddonProducts, INTERNAL_IDS.NAD_NASAL) || null;
        },
        sermorelinProductRef() {
            const p = getProductByInternalId(this.apiProducts, INTERNAL_IDS.SERMORELIN);
            return (p && p.is_active === true && p.is_addon === true && passesGenderRestriction(p, this.user)
                && pricedTerms(p, UPSELL_TERMS).length) ? p : null;
        }
    },
    methods: {
        /* ===== NEW generic, pricing_plans-based helpers (adapter-backed) ===== */
        // Resolve a product's plan for the given terms (0=one-time,1=monthly,3=3-month).
        productPlan(product, terms) {
            return getPlan(product, terms);
        },
        productPlans(product) {
            return getPlansForProduct(product);
        },
        // Current price for a product+terms as { dollars, cents }.
        productPriceParts(product, terms) {
            const plan = getPlan(product, terms);
            return formatPrice(plan ? plan.price : 0);
        },
        // Strikethrough "old" price = ceil(price * 1.25).
        productOldPrice(product, terms) {
            const plan = getPlan(product, terms);
            return plan ? inflatedPrice(plan.price) : 0;
        },
        // First DB image URL for a product (by object, or by cart item product_id).
        apiImage(product) {
            return getProductImage(product);
        },
        apiImageById(productId) {
            return getProductImage(getProductById(this.apiProducts, productId));
        },
        // Add/replace any product in the cart at given terms (generic; pricing_plans-based).
        addProductToCart(product, terms) {
            const plan = getPlan(product, terms);
            if (!plan) return;
            const item = {
                plan_id: plan.plan_id,
                product_id: plan.product_id,
                name: plan.name,
                price: plan.price,
                retail_price: plan.price,
                terms: plan.terms,
                quantity: 1,
                is_addon: true
            };
            const idx = this.localCartItems.findIndex(i => i.product_id === item.product_id);
            if (idx >= 0) {
                this.localCartItems.splice(idx, 1, item);
            } else {
                this.localCartItems.push(item);
            }
        },
        // Load products from the DB (visibility + pricing both live on each product),
        // then start the funnel on the first active step. On failure, apiProducts stays
        // empty so every step is hidden and the user is sent straight to the thank-you
        // page — a clean skip rather than a broken/empty upsell on this post-purchase page.
        async loadUpsellData() {
            this.productsLoading = true;
            try {
                const [apiProducts, subscriptions] = await Promise.all([fetchProductsFromServer(), this.fetchSubscriptions()]);
                this.apiProducts = Array.isArray(apiProducts) ? apiProducts : [];
                this.holdsNadPlus = holdsNad(subscriptions, this.apiProducts);
            } catch (error) {
                console.error('[UpSell] loadUpsellData — ERROR:', error);
                this.apiProducts = [];
            }
            // Start each plan picker on a length the product sells, so no step opens on $0.
            if (this.bundleProduct) this.bundlePaymentTerms = pickTerms(this.bundleProduct, this.bundlePaymentTerms, CARD_TERMS);
            if (this.selectedNadProduct) this.nadPaymentPlan = pickTerms(this.selectedNadProduct, this.nadPaymentPlan, UPSELL_TERMS);
            if (this.sermorelinProductRef) this.sermorelinPaymentPlan = pickTerms(this.sermorelinProductRef, this.sermorelinPaymentPlan, UPSELL_TERMS);
            // Every upsell inactive (or the fetch failed) → no product step to show, so
            // skip straight to the thank-you page. Keep the overlay up (don't clear
            // productsLoading) so the empty confirmation step never flashes, and use
            // replace so Back doesn't trap the user on a dead upsell.
            if (this.firstStep === 5) {
                this.$router.replace('/payment/thanks');
                return;
            }
            this.productsLoading = false;
            // Visibility is known — start the funnel on the first active step.
            this.active_el = this.firstStep;
        },
        // Current terms for an individual-step product (defaults to the funnel terms, or
        // the product's first priced length when it has no plan for them).
        productTermsFor(product) {
            if (!product) return this.paymentTerms || 1;
            const t = this.productTerms[product.id];
            return t == null ? pickTerms(product, this.paymentTerms || 1, CARD_TERMS) : t;
        },
        // Set an individual product's terms and re-sync its cart line if already added.
        setProductTerms(product, terms) {
            if (!product) return;
            this.$set(this.productTerms, product.id, terms);
            if (this.isInCart(product.id)) {
                this.addProductToCart(product, terms);
            }
        },
        // All DB image URLs for a product (drives the per-product sliders).
        productImages(product) {
            if (!product || !Array.isArray(product.images)) return [];
            return product.images.map(i => normalizeImageUrl(i && i.url)).filter(Boolean);
        },
        // Split a product's bullets into two balanced columns for the benefits grid.
        // product_bullets arrives as an array (new contract) or a { bullet1..N } object
        // (legacy shape) — handle both rather than assume one.
        splitBenefits(product) {
            const raw = product && product.product_bullets;
            const bullets = Array.isArray(raw)
                ? raw.filter(Boolean)
                : (raw && typeof raw === 'object' ? Object.values(raw).filter(Boolean) : []);
            const half = Math.ceil(bullets.length / 2);
            return { left: bullets.slice(0, half), right: bullets.slice(half) };
        },
        // One-time / monthly / 3-month plan prices for a product, from its pricing_plans.
        // Each entry is { dollars, cents } or null when that plan doesn't exist.
        planData(product) {
            const oneTime = getPlan(product, 0);
            const monthly = getPlan(product, 1);
            const threeMonth = getPlan(product, 3);
            return {
                oneTime: oneTime ? formatPrice(oneTime.price) : null,
                monthly: monthly ? formatPrice(monthly.price) : null,
                threeMonthAvg: threeMonth ? formatPrice(threeMonth.price / 3) : null,
                threeMonthTotal: threeMonth
                    ? Number(threeMonth.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : null
            };
        },
        // Get the next enabled step after the given step
        nextStep(afterStep) {
            return this.activeSteps.find(s => s > afterStep) || 5;
        },
        // Get the previous enabled step before the given step
        prevStep(beforeStep) {
            const reversed = [...this.activeSteps].reverse();
            return reversed.find(s => s < beforeStep) || this.firstStep;
        },
        async handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
            }
        },

        async fireGTM() {
            try {

                const amount = this.$route.query.amount;

                try{
                    if (window.tracking) {
                        window.tracking.event('purchase', {
                            funnel_step: 15,
                            event_value: amount,
                            currency: 'USD',
                            event_id: crypto.randomUUID()
                        });
                    }
                }catch(error){
                    console.log(error)
                }
                const transid = this.$route.query.trans_id;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'purchase',
                    'ecommerce': {
                        'transaction_id': transid,
                        'value': amount,
                        'currency': 'USD',
                    }
                });
                console.log(":white_check_mark: Google pixel fired with amount:", amount);
            } catch (error) {
                console.error(":x: Error firing Google pixel:", error);
            }

        },
        // Open the Learn More modal for a product. Products with a dedicated template
        // (template_to_use === 2, e.g. NAD) open the store's special template modal;
        // everything else uses the generic upsell modal. Mirrors StoreLearnMoreModal.
        openLearnMore(productId) {
            const product = getProductById(this.apiProducts, productId);
            if (product && product.template_to_use === 2) {
                this.$refs.storeLearnMoreModal.openLearnMore(productId);
                return;
            }
            this.$refs.learnMoreModal.openLearnMore(productId);
        },
        initSliders() {
            // Initialize all sliders on the page
            this.$nextTick(() => {
                this.setupSliderArrows();
                this.setupTouchEvents();
            });
        },

        setupSliderArrows() {
            // Find all sliders and attach click handlers to arrows
            const sliders = this.$el.querySelectorAll('.w-slider[data-slider-key]');
            sliders.forEach((slider) => {
                const sliderKey = slider.dataset.sliderKey;
                if (!sliderKey || !this.sliders[sliderKey]) return;

                // Skip if already initialized (prevent duplicate listeners)
                if (slider.dataset.initialized === 'true') return;
                slider.dataset.initialized = 'true';

                const leftArrow = slider.querySelector('.w-slider-arrow-left');
                const rightArrow = slider.querySelector('.w-slider-arrow-right');
                const slides = slider.querySelectorAll('.w-slide');

                // Store total slides count
                this.sliders[sliderKey].totalSlides = slides.length;

                if (leftArrow) {
                    leftArrow.addEventListener('click', () => this.previousSlide(sliderKey));
                }
                if (rightArrow) {
                    rightArrow.addEventListener('click', () => this.nextSlide(sliderKey));
                }

                // Initialize slide positions
                this.updateSlidePositions(slider, sliderKey);
            });
        },

        setupTouchEvents() {
            const sliders = this.$el.querySelectorAll('.w-slider[data-slider-key]');
            sliders.forEach((slider) => {
                const sliderKey = slider.dataset.sliderKey;
                if (!sliderKey || !this.sliders[sliderKey]) return;

                // Skip if touch already initialized
                if (slider.dataset.touchInitialized === 'true') return;
                slider.dataset.touchInitialized = 'true';

                const mask = slider.querySelector('.w-slider-mask');
                if (mask) {
                    mask.addEventListener('touchstart', (e) => this.handleTouchStart(e));
                    mask.addEventListener('touchmove', (e) => this.handleTouchMove(e));
                    mask.addEventListener('touchend', () => this.handleTouchEnd(sliderKey));
                }
            });
        },

        getSliderKey(index) {
            const keys = ['bundle', 'nad', 'sermorelin'];
            return keys[index] || 'bundle';
        },

        previousSlide(sliderKey) {
            const slider = this.sliders[sliderKey];
            if (!slider || slider.isAnimating) return;

            slider.isAnimating = true;
            if (slider.currentSlide > 0) {
                slider.currentSlide--;
            } else {
                slider.currentSlide = slider.totalSlides - 1;
            }

            this.animateSlider(sliderKey);
            setTimeout(() => {
                slider.isAnimating = false;
            }, 500);
        },

        nextSlide(sliderKey) {
            const slider = this.sliders[sliderKey];
            if (!slider || slider.isAnimating) return;

            slider.isAnimating = true;
            if (slider.currentSlide < slider.totalSlides - 1) {
                slider.currentSlide++;
            } else {
                slider.currentSlide = 0;
            }

            this.animateSlider(sliderKey);
            setTimeout(() => {
                slider.isAnimating = false;
            }, 500);
        },

        animateSlider(sliderKey) {
            const slider = this.$el.querySelector(`.w-slider[data-slider-key="${sliderKey}"]`);
            if (slider) {
                this.updateSlidePositions(slider, sliderKey);
            }
        },

        updateSlidePositions(sliderEl, sliderKey) {
            const slider = this.sliders[sliderKey];
            if (!slider) return;

            const mask = sliderEl.querySelector('.w-slider-mask');
            const slides = sliderEl.querySelectorAll('.w-slide');

            if (mask && slides.length > 0) {
                const slideWidth = mask.offsetWidth;
                slides.forEach((slide) => {
                    slide.style.transition = 'transform 500ms ease';
                    slide.style.transform = `translateX(${-slider.currentSlide * slideWidth}px)`;
                });

                // Update nav dots if present
                const navDots = sliderEl.querySelectorAll('.w-slider-nav > div');
                navDots.forEach((dot, i) => {
                    dot.classList.toggle('w-active', i === slider.currentSlide);
                });
            }
        },

        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },

        handleTouchMove(event) {
            this.endX = event.touches[0].clientX;
        },

        handleTouchEnd(sliderKey) {
            const swipeDistance = this.startX - this.endX;
            const swipeThreshold = 50;

            if (swipeDistance > swipeThreshold) {
                this.nextSlide(sliderKey);
            } else if (swipeDistance < -swipeThreshold) {
                this.previousSlide(sliderKey);
            }
        },

        // Add the bundle to the cart, then skip past the individual step.
        addBundleAndSkip() {
            this.addProductToCart(this.bundleProduct, this.bundlePaymentTerms);
            setTimeout(() => {
                this.active_el = this.nextStep(2);
            }, 500);
        },

        // Go to next enabled step after current step
        goToNextStep() {
            this.active_el = this.nextStep(this.active_el);
        },

        // Go back to previous enabled step
        goBack() {
            if (this.active_el <= this.firstStep) return;
            this.active_el = this.prevStep(this.active_el);
        },

        // Go to a specific step (only if enabled, otherwise next enabled)
        goToStep(step) {
            if (this.activeSteps.includes(step)) {
                this.active_el = step;
            } else {
                this.active_el = this.nextStep(step - 1);
            }
        },

        // Check if product is in cart
        isInCart(productId) {
            return this.localCartItems.some(item => item.product_id === productId);
        },

        // Remove item from cart
        removeFromCart(planId) {
            const index = this.localCartItems.findIndex(item => item.plan_id === planId);
            if (index >= 0) {
                this.localCartItems.splice(index, 1);
            }
        },

        // Clear entire cart
        clearCart() {
            this.localCartItems = [];
        },

        // Add NAD to cart with the selected product/plan and go to the next enabled step.
        addNadAndNext() {
            if (this.isNadInCart()) {
                setTimeout(() => { this.active_el = this.nextStep(3); }, 500);
                return;
            }
            this.addProductToCart(this.selectedNadProduct, this.nadPaymentPlan);
            try {
                if (window.tracking && this.selectedNadProduct) {
                    window.tracking.event('add_to_cart', { product: this.selectedNadProduct.name });
                }
            } catch (error) {
                console.log(error);
            }
            setTimeout(() => { this.active_el = this.nextStep(3); }, 500);
        },

        // Check if any active NAD product (injectable or nasal) is in the cart.
        isNadInCart() {
            return this.localCartItems.some(item => this.nadProductIds.includes(item.product_id));
        },

        // Re-sync the NAD cart line when the plan or medication type changes. The med-type
        // toggle can switch nasal<->injectable, so drop any existing NAD line first.
        updateNadInCart() {
            const plan = getPlan(this.selectedNadProduct, this.nadPaymentPlan);
            if (!plan) return;
            this.localCartItems = this.localCartItems.filter(i => !this.nadProductIds.includes(i.product_id));
            this.localCartItems.push({
                plan_id: plan.plan_id,
                product_id: plan.product_id,
                name: plan.name,
                price: plan.price,
                retail_price: plan.price,
                terms: plan.terms,
                quantity: 1,
                is_addon: true
            });
        },

        // Add Sermorelin to cart with the selected plan and go to the next enabled step.
        addSermorelinAndNext() {
            if (this.sermorelinProductRef && this.isInCart(this.sermorelinProductRef.id)) {
                setTimeout(() => { this.active_el = this.nextStep(4); }, 500);
                return;
            }
            this.addProductToCart(this.sermorelinProductRef, this.sermorelinPaymentPlan);
            try {
                if (window.tracking && this.sermorelinProductRef) {
                    window.tracking.event('add_to_cart', { product: this.sermorelinProductRef.name });
                }
            } catch (error) {
                console.log(error);
            }
            setTimeout(() => { this.active_el = this.nextStep(4); }, 500);
        },

        // Re-sync the Sermorelin cart line when its payment plan changes.
        updateSermorelinInCart() {
            this.addProductToCart(this.sermorelinProductRef, this.sermorelinPaymentPlan);
        },

        // Format cart item price for display
        formatCartItemPrice(price) {
            const priceStr = price.toFixed(2);
            const [rawDollars, cents] = priceStr.split('.');
            const dollars = Number(rawDollars).toLocaleString('en-US');
            return { dollars, cents };
        },

        // Format cart total for display
        formatCartTotal() {
            const total = this.cartTotal;
            const priceStr = total.toFixed(2);
            const [rawDollars, cents] = priceStr.split('.');
            const dollars = Number(rawDollars).toLocaleString('en-US');
            return { dollars, cents };
        },

        handlePaymentError(message) {
            this.paymentError = true;
            this.errorMessage = message || 'Invalid card details. Please check your card information.';
            this.submitted = false;
        },

        handlePaymentToken(pmToken) {
            this.paymentToken = pmToken;
            this.confirmOrder();
        },

        cancelCardUpdate() {
            this.showCardUpdate = false;
            this.paymentToken = null;
        },

        // Fetch the card on file (same endpoint + shape the billing page uses).
        // If none is attached — or the lookup fails — force the add-card form so the
        // user must enter a card before they can complete the order.
        // The shopper's subscriptions, the order just paid included, or null when the
        // call fails. Null keeps the NAD step hidden: one NAD+ per order.
        async fetchSubscriptions() {
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/subscription-items`);
                return response.data.status === 'success' ? response.data.subscriptions : null;
            } catch (error) {
                console.error('[UpSell] fetchSubscriptions — ERROR:', error);
                return null;
            }
        },
        async fetchCardOnFile() {
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/subscription-items`);
                if (response.data.status === 'success') {
                    this.paymentData = response.data.payment_data;
                }
            } catch (error) {
                console.error('[UpSell] fetchCardOnFile — ERROR:', error);
            } finally {
                if (!this.hasCardOnFile) {
                    this.showCardUpdate = true;
                }
            }
        },

        // Confirm order and process payment
        async confirmOrder() {
            // Block a duplicate user click while a charge is already in flight; allow the
            // legitimate re-entry from the Payment Element token callback (paymentToken is set then).
            if (this.submitted && !this.paymentToken) return;
            if (this.localCartItems.length === 0) {
                this.paymentError = true;
                this.errorMessage = 'Your cart is empty. Please add items before confirming.';
                return;
            }

            // No card on file and no new card entered → refuse to charge; force a card.
            if (!this.hasCardOnFile && !this.hasCardInput && !this.paymentToken) {
                this.showCardUpdate = true;
                this.paymentError = true;
                this.errorMessage = 'Please add a payment method to continue.';
                return;
            }

            // If user chose to update card and hasn't confirmed yet, trigger Payment Element
            if (this.showCardUpdate && !this.paymentToken && this.$refs.stripePayment) {
                this.submitted = true;
                this.paymentError = false;
                this.errorMessage = '';
                await this.$refs.stripePayment.confirmPayment();
                // confirmPayment will emit @token (-> handlePaymentToken -> confirmOrder again) or @error
                return;
            }

            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;
            this.errorMessage = '';

            // Determine if using existing card on file or new payment token
            const useExistingCard = !this.showCardUpdate && !this.paymentToken;

            try {
                // Track checkout event
                if (window.tracking) {
                    window.tracking.event('begin_checkout', {
                        items: this.localCartItems.map(item => item.name),
                        total: this.cartTotal
                    });
                }

                let paymentData = {
                    payment_terms: this.paymentTerms || 1,
                    user_id: this.user?.id,
                    id: this.user?.id,
                    cardToken: this.paymentToken || '',
                    cardBrand: '',
                    amount: Math.round(this.cartTotal * 100),
                    discount: 0,
                    medication: '',
                    couponCode: '',
                    drug_mode: '',
                    couponId: null,
                    paymentMethod: 'card',
                    cartItems: this.localCartItems,
                    cardDetails: [],
                    planId: '',
                    cardBin: '',
                    cardLast4: '',
                    cartTotal: this.cartTotal,
                    cartTotalNoDiscount: this.cartTotal,
                    offer: '',
                    billingAddress: {},
                    shippingAddress: {
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        state: '',
                        zip: ''
                    },
                    firstName: this.user?.first_name || '',
                    lastName: this.user?.last_name || '',
                    email: this.user?.email || '',
                    mainProductTotal: this.cartTotal,
                    addonTotal: 0,
                    totalOrderAmount: this.cartTotal,
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: '',
                    tracking_session_id: window?.trackingSessionId || 'unknown',
                    useExistingCard: useExistingCard,
                    is_upsell: true,
                };

                console.log('[UpSell] confirmOrder — SENDING paymentData:', JSON.stringify(paymentData, null, 2));
                const response = await this.$axios.post(`${this.baseUrl}/api/upsell-checkout`, paymentData, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });
                console.log('[UpSell] confirmOrder — RESPONSE:', JSON.stringify(response.data, null, 2));

                if (response.data.status === 'success') {
                    // Append upsell products to productsPurchased in localStorage
                    const existing = JSON.parse(localStorage.getItem('productsPurchased') || '[]');
                    const upsellItems = this.localCartItems.map(item => ({
                        name: item.name,
                        price: parseFloat(item.price).toFixed(2)
                    }));
                    localStorage.setItem('productsPurchased', JSON.stringify([...existing, ...upsellItems]));

                    // Track purchase event
                    if (window.tracking) {
                        window.tracking.event('purchase', {
                            items: this.localCartItems.map(item => item.name),
                            total: this.cartTotal,
                            transaction_id: response.data.transaction_id
                        });
                    }
                    this.$router.push('/payment/thanks');
                } else {
                    this.paymentError = true;
                    this.errorMessage = response.data.message || 'Payment failed. Please try again.';
                    this.submitted = false; // re-enable only on failure; success stays locked through the redirect
                }
            } catch (error) {
                console.error('[UpSell] confirmOrder — ERROR:', error);
                console.error('[UpSell] confirmOrder — ERROR response:', JSON.stringify(error.response?.data, null, 2));
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please check your card details and try again.';
                // Reset the payment intent so user can retry
                if (this.$refs.stripePayment) {
                    this.$refs.stripePayment.resetElement();
                }
                this.submitted = false; // re-enable on error
            } finally {
                this.paymentToken = null;
            }
        },

        // Get masked card number for display
        getMaskedCard() {
            if (this.user?.card_last_four) {
                return `•••• •••• •••• ${this.user.card_last_four}`;
            }
            return 'Card on file';
        }
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
        // Clean up event listeners
        const sliders = this.$el.querySelectorAll('.w-slider');
        sliders.forEach((slider) => {
            const leftArrow = slider.querySelector('.w-slider-arrow-left');
            const rightArrow = slider.querySelector('.w-slider-arrow-right');
            const mask = slider.querySelector('.w-slider-mask');

            if (leftArrow) leftArrow.removeEventListener('click', this.previousSlide);
            if (rightArrow) rightArrow.removeEventListener('click', this.nextSlide);
            if (mask) {
                mask.removeEventListener('touchstart', this.handleTouchStart);
                mask.removeEventListener('touchmove', this.handleTouchMove);
                mask.removeEventListener('touchend', this.handleTouchEnd);
            }
        });
    }
}
</script>

<style>
@media (max-width: 768px) {
    .inclusions-right-div {
        position: relative;
        width: 20%;
    }
}

.new-upsell-cart-button.var1.flow {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}

.cart_btn {
    height: 18px !important;
    width: 18px !important;
}

/* Added to cart state */
.new-upsell-cart-button.added,
.new-upsell-cart-button-2.added {
    background-color: #22c55e !important;
    border-color: #22c55e !important;
}

.new-upsell-cart-button.added:hover,
.new-upsell-cart-button-2.added:hover {
    background-color: #16a34a !important;
    border-color: #16a34a !important;
}

.div-block-2293,
.div-block-2296,
.upsell_option {
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.div-block-2293:hover,
.div-block-2296:hover,
.upsell_option:hover {
    border-color: #4f46e5;
}

.div-block-2293.selected .radio-button-field-5,
.div-block-2296.selected .radio-button-field-5,
.upsell_option.selected .radio-button-field-5 {
    background-color: #c9e8ff;
    border-color: #000;
}

.upsell_option.selected .radio-button-field-3 {
    background-color: #c9e8ff;
    border-color: #000;
}

/* Order confirmation styles */
.order-item-price.included {
    color: #22c55e;
    font-weight: 600;
    font-size: 14px;
}

/* Fix product images in order confirmation - show full bottle */
.inclusion-img-div {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.inclusion-img-div img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
}

.empty-cart-message {
    padding: 40px 20px;
    text-align: center;
    background-color: #f9fafb;
    border-radius: 8px;
    margin: 20px 0;
}

.trash-link {
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.trash-link:hover {
    opacity: 1;
}

/* Loading Overlay */
.loading-overlay2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
}

/* Error Popup */
.error_popup {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, 0.5) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999998 !important;
}

.error_box {
    background: white;
    padding: 30px;
    border-radius: 10px;
    max-width: 400px;
    text-align: center;
}

.text-block-1101 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #e74c3c;
}

.text-block-1102 {
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
}

.close-error-link {
    display: inline-block;
    padding: 10px 20px;
    background: #000;
    color: #fff;
    text-decoration: none;
    border-radius: 5px;
}

/* Payment Method Section */
.payment-method-section {
    margin-top: 15px;
}

.payment-method-header {
    margin: 15px 0;
}

.existing-card-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 15px;
}

.card-info-row {
    display: flex;
    align-items: center;
    gap: 15px;
}

.card-icons {
    display: flex;
    gap: 5px;
}

.card-icon {
    height: 24px;
    width: auto;
}

.card-number {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
}

.update-card-link,
.cancel-update-link {
    color: #666;
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
}

.update-card-link:hover,
.cancel-update-link:hover {
    color: #000;
}

.update-card-form {
    padding: 15px;
    background: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 15px;
}

.card-top-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.cards-div {
    display: flex;
    gap: 5px;
}


.continue-button.disabled {
    opacity: 0.6;
    pointer-events: none;
}

@media screen and (max-width: 480px) {
    .button-149-copy{
        font-size: 12px;
    }
    .button-149{
        font-size: 12px;
    }
    .div-block-2297 {
        margin-top: 15px;
    }
    .pay-type-div {
        margin-top: 30px;
    }
}

/* On mobile, disable the blue active state on Learn More buttons */
@media (max-width: 768px) {
    .button-176,
    .button-153,
    .button-153-copy,
    .upsell_learnbutton-2 {
        -webkit-tap-highlight-color: transparent !important;
    }

    .button-153,
    .button-153:active,
    .button-153:focus,
    .button-153:hover,
    .button-153-copy,
    .button-153-copy:active,
    .button-153-copy:focus,
    .button-153-copy:hover {
        background-color: #fff !important;
        color: #000 !important;
        border-color: #000 !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .button-176,
    .button-176:active,
    .button-176:focus,
    .button-176:hover {
        background-color: #e9ff86 !important;
        color: #000 !important;
        border-color: #000 !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .upsell_learnbutton-2,
    .upsell_learnbutton-2:active,
    .upsell_learnbutton-2:focus,
    .upsell_learnbutton-2:hover {
        outline: none !important;
        box-shadow: none !important;
    }
}

/* Move Learn More text down */
.learn-more-text {
    display: inline-block;
    transform: translateY(1px);
}

/* Move payment term text up */
.text-block-1788 {
    transform: translateY(-1px);
}

/* Fix back button container on desktop - keep absolute but fix sizing */
.div-block-2253 {
    position: absolute !important;
    right: 6% !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    bottom: auto !important;
    left: auto !important;
    width: 44px !important;
    height: 44px !important;
    padding: 0 !important;
}

.div-block-2253 .link-block-109 {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.div-block-2253 .image-692 {
    width: 20px !important;
    height: auto !important;
}

/* Pointer cursor for all clickable buttons */
.button-149-copy,
.button-176,
.button-153,
.button-153-copy,
.new-upsell-cart-button,
.new-upsell-cart-button-2,
.upsell_learnbutton-2 {
    cursor: pointer !important;
}
</style>

<style scoped>
/* Product image tiles: give each a fixed (near-square) size and let the image
   fill it, instead of a tiny image floating in a stretched blue box. Sizes mirror
   the reference upsell (forms-newself .../glp1-deal-1/upsell/upsell.css) exactly. */

/* Step 1 — bundle breakdown thumb  (ref .us-bundle-item__img 76x70) */
.choice-img-div-copy-2 {
    width: 76px;
    min-width: 76px;
    height: 70px;
    flex-shrink: 0;
    padding: 0;
    overflow: hidden;
}

.choice-img-div-copy-2 .newupsell_product_img,
.choice-img-div-copy-2 .newupsell_product_img.rxpill {
    width: 100%;
    height: 100%;
    padding: 0;
    object-fit: cover;
}

/* Step 2 — "Purchase Individually" thumb  (ref .us-solo-card__img 108x98) */
.choice-img-div {
    width: 108px;
    min-width: 108px;
    height: 98px;
    flex-shrink: 0;
    padding: 0;
    overflow: hidden;
}

.choice-img-div .choice-img,
.choice-img-div .choice-img.b12 {
    width: 100%;
    height: 100%;
    padding: 0;
    object-fit: cover;
}

/* Step 3 — NAD med-type toggle thumb  (ref .us-nad__med-thumb 30x30) */
.medtype-img-2 {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

/* Step 5 — confirmation cart item thumb  (ref .us-cart-item__img 56x56, contain) */
.inclusion-img-div {
    width: 56px;
    min-width: 56px;
    height: 56px;
    flex-shrink: 0;
    overflow: hidden;
}

@media (max-width: 768px) {
    .choice-img-div-copy-2 {
        width: 70px;
        min-width: 70px;
        height: 64px;
    }

    .choice-img-div {
        width: 80px;
        min-width: 80px;
        height: 74px;
    }

    .inclusion-img-div {
        width: 48px;
        min-width: 48px;
        height: 48px;
    }
}
</style>